/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
const dtUpdate = require ('./users-dt-update')

export const tableDetail = {
    entity: 'users',
    dest: 'users',

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"users", "elem":"fullcont", "id":"users-fullcont", 
                                              "act":"selectOne", "entity":"users", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{ "dest":"users", "elem":"dt", "act":"trMenu", 
                                                  "id":"trMenu",  "entity":"users", 
                                                   "dbid": "#dbid"  } ]  }'`, //"username": "#username"

    filter: {
        mainFilterFields : ["__name", "last_name", "users.username"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Reulsts', span: '---' },
                                                { label:'No Reulsts', span: '---' } ] })
        return newData
    }

    data.forEach((elem)=>{

        const statusStyle  = dtUpdate.getstatusStyle(elem)   
        
        if(!elem.hasOwnProperty('sex')){
            elem.sex = "NA";
        }

        let elemName    = "";
        let letter      = "";
        let avatarColor = "";
        let avatar      = "";

        if (elem.avatar == "") {
            avatar = "";
            elemName = elem.__name;
            
            // Dividir el nombre en palabras
            let nameParts = elemName.split(" ");

            // Filtrar las palabras para eliminar las que no empiezan con letras (ej. '&')
            let validParts = nameParts.filter(part => /^[A-Za-z]/.test(part));
            
            // Tomar la primera letra de cada palabra (si la palabra existe)
            if (validParts.length > 0) {
                letter += validParts[0].charAt(0); // Primera letra del primer nombre
            }
            if (validParts.length > 1) {
                letter += validParts[1].charAt(0); // Primera letra del segundo nombre
            }
        } else {
            avatar = elem.avatar;
            elemName = "";
            letter = "";
        }

        if (elem.avatarColor == "") {
            avatarColor = '12af45'
        }else{
            avatarColor = elem.avatarColor
        }

        newData.push(
                {   id: elem.id, sex: elem.sex,  // username:elem.username,
                     colum: [  { 
                           label: elem.__name, span: elem.last_name,
                            style:{ 
                                tdClass:'td-bluex tdWithAvatar',  
                                avatar:avatar,
                                avatarColor: avatarColor, 
                                avatarLetter: letter.toUpperCase()                          
                            } 
                                 },
                                 { label: elem.username,  span: elem.phone        },    
                                 { label: elem.type,  span: elem.entities        },   
                                 { label: elem.phone,  span: elem.email        }, 
                                 
                                 {  label: statusStyle.title,  
                                    span: statusStyle.des,      
                                    style:{ 
                                         tdClass:`tdWithIcon ${statusStyle.color}`,  
                                         svg:`./css/applications/nurse/svg-nurse.svg#${statusStyle.svg}`,
                                     } 
                                 }  ]    
                }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/